module.exports = __webpack_public_path__ + "img/BnPFullLogo_tiny.9a6d23dc.png";